export const divisionLinkMap = {
  IT: '/tech',
  BO: '/office',
  OP: '/operations',
};

export const getLinkFromDivisionName = (divisionName: string | string[] | null | undefined) => {
  if (!divisionName) {
    return '/tech';
  }
  return (
    divisionLinkMap[divisionName as keyof typeof divisionLinkMap] ?? '/tech'
  );
};
